import React from 'react';
import Icon from '../../../components/AppIcon';
import { QuickStat } from '../types';

interface QuickStatsProps {
  stats: QuickStat[];
}

const QuickStats = ({ stats }: QuickStatsProps) => {
  const getTrendIcon = (trend: string) => {
    switch (trend) {
      case 'up':
        return 'TrendingUp';
      case 'down':
        return 'TrendingDown';
      default:
        return 'Minus';
    }
  };

  const getTrendColor = (trend: string) => {
    switch (trend) {
      case 'up':
        return 'text-success';
      case 'down':
        return 'text-error';
      default:
        return 'text-muted-foreground';
    }
  };

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
      {stats.map((stat, index) => (
        <div
          key={index}
          className="bg-card border border-border rounded-lg p-4 hover:shadow-md transition-all duration-200"
        >
          <div className="flex items-start justify-between mb-3">
            <div
              className="flex items-center justify-center w-10 h-10 rounded-md"
              style={{ backgroundColor: `${stat.color}20` }}
            >
              <Icon name={stat.icon} size={20} style={{ color: stat.color }} />
            </div>
            <div className="flex items-center gap-1">
              <Icon
                name={getTrendIcon(stat.trend)}
                size={14}
                className={getTrendColor(stat.trend)}
              />
              <span className={`text-xs font-medium ${getTrendColor(stat.trend)}`}>
                {Math.abs(stat.change)}%
              </span>
            </div>
          </div>
          <p className="text-2xl font-bold text-foreground mb-1">{stat.value}</p>
          <p className="text-xs text-muted-foreground">{stat.label}</p>
        </div>
      ))}
    </div>
  );
};

export default QuickStats;